import { createBrowserRouter } from 'react-router-dom';

// project imports
import App from 'App';
import { BASE_PATH } from 'config';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
    [
        {
            element: <App />,
            children: [MainRoutes, LoginRoutes, AuthenticationRoutes]
        }
    ],
    { basename: BASE_PATH }
);

export default router;
